import { render, staticRenderFns } from "./ForcedRegistrationDetailsPage.vue?vue&type=template&id=f5a6cacc&scoped=true&"
import script from "./ForcedRegistrationDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ForcedRegistrationDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ForcedRegistrationDetailsPage.vue?vue&type=style&index=0&id=f5a6cacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a6cacc",
  null
  
)

export default component.exports